import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';


const EditpopMain = () => {

  var checkname=localStorage.getItem('username')

    let EditData = JSON.parse(localStorage.getItem("EditData"));


        let userName = EditData.map((item) => item.userName);

        let UserName = userName[0]
    
        let email= EditData.map((item) => item.email);
        let passwordHash=EditData.map((item) => item.passwordHash);

        let Email =email[0]
        let active= EditData.map((item) => item.active);

        let ActiveState = active[0]
   
        let id= EditData.map((item) => item.id)

        let Id= id[0]

    // useEffect(()=>{  editoat(Id)


    // }, [])

     const token = JSON.parse(localStorage.getItem('usertoken'));
    // const [Editoat, setEditoat] =useState([])

    //       function editoat(Id){

           


    //         const body =
    //         {
              
    //          id:Id
    //         }
    //         console.log('body',body);
      
          
    //         axios({
    //                method:"POST",
    //                url :`${BASE_URL}/Oat/Getparticularid`,
    //                data:body, 
    //                headers: {
    //                     "Content-type": "application/json",
    //                     "Authorization": "Bearer " + `${token}`,
    //                 }     
    //             }) 
                
           
    //             .then((response) =>{
    //               console.log(response.data);
             
             
    //               setEditoat(response.data)

                 
             
    //            })
    //            .catch(error => {
    //              console.log(error);
                 
    //            })
      
    //       }


 //Genarete Password

        

       

 
 
 
      


 function GeneratePassword() {
 

   var NewPass =Pass();


   console.log(NewPass)
   const body ={email: Email, newPassword:NewPass}


axios({
     method: "POST",
     url :`${BASE_URL}/Oat/Generatepassword`,
      data:body, 
      headers: {
       "Content-Type": "application/json",
      
      }     
      }) 
      .then((response) =>{
        console.log(response.data);
      
      
       
      
           if(response.data.status === "Success"){
            document.getElementById("Gpass").innerHTML=NewPass;
            // toast.success("Password Generated" + " "+ UserName, {
            //   position: "top-center",
            //   autoClose: 3200,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   className: 'toast-message'
            //   });
            // alert("Password Generated Successfully!")
           
            document.getElementById("GenerateSuccess-Oat").style.display="block"
            setTimeout(() => {
              document.getElementById("GenerateSuccess-Oat").style.display="none"
             
            }, 3000);
          }
        })
        .catch(error => {
          console.log(error);
          alert("failed !")

        })

 }

 const Allowed = {
    Uppers: "QWERTYUIOPASDFGHJKLZXCVBNM",
    Lowers: "qwertyuiopasdfghjklzxcvbnm",
    Numbers: "1234567890",
    Symbols: "!@#$%^&*"
}

const getRandomCharFromString = (str) => str.charAt(Math.floor(Math.random() * str.length))

/**
 * the generated password will be @param length, which default to 8, 
 * and will have at least one upper, one lower, one number and one symbol
 * @param {number} length - password's length
 * @returns a generated password
 */
const Pass = (length = 8) => {
    let pwd = "";
    pwd += getRandomCharFromString(Allowed.Uppers);  // pwd will have at least one upper
    pwd += getRandomCharFromString(Allowed.Lowers);  // pwd will have at least one lower
    pwd += getRandomCharFromString(Allowed.Numbers);  // pwd will have at least one number
    pwd += getRandomCharFromString(Allowed.Symbols); // pwd will have at least one symbol
    for (let i = pwd.length; i < length; i++)
        pwd += getRandomCharFromString(Object.values(Allowed).join(''));  // fill the rest of the pwd with random characters
    return pwd

   

}
// function Pass(){
   
//  var pass = '';
//  var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
//          'abcdefghijklmnopqrstuvwxyz' +'0123456789' +'@#$';
   
//  for (let i = 1; i <= 8; i++) {
//      var char = Math.floor(Math.random()
//                  * str.length + 1);
       
//      pass += str.charAt(char)
//  }
   
//  return pass;

//    }

   //activestatus usestate




  const [Active, setActive] =useState(" ")


  
 




  ///function update

  function updateoat(){
    //var Security = document.getElementById("Gpassword").value
 
 
    if(Active===0){

      var Action =0
     }
     else if(Active===1){
      var Action= 1

     }

     else{
        var Action=ActiveState

     }
    
    // if(SPassword!=0){
        
    //   var SecurityPass = SPassword
    // }
    // else{
    //   var SecurityPass = Security

    // }
      
    // var Gpass = document.getElementById("Gpass").value;
    var EditName = document.getElementById("EditName").value;


    if(!EditName){
    document.getElementById("ErrA").innerHTML="UserName Required"

    }
    else if(EditName){

      document.getElementById("ErrA").innerHTML=" "

      const body =
      {
        
        userName:EditName, 
        id:Id,
        active:Action,
        normalizedUserName:EditName
       
     
      }
      console.log('body',body);

    
      axios({
             method:"POST",
             url :`${BASE_URL}/Oat/UpdateAspNetUser`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " + `${token}`,
              }     
          }) 
  
         .then((response) =>{
         console.log(response.data);
    
    
         if(response.data.status === "Success"){
         
              // toast.success("Updated")
               //alert("Updated Successfully!")
             
               document.getElementById("UpdateSuccess-Oat").style.display="block"

              if(checkname===UserName){

                localStorage.setItem('username',EditName);
            }
              setTimeout(() => {
                document.getElementById("UpdateSuccess-Oat").style.display="none"
                window.location.href="/?#/Oatadduser"
                
              }, 2000);
            }
    
      })
      .catch(error => {
        console.log(error);
        alert("failed !")
      // toast.warning("failed to Update")   
      })
        

    }
    

  }



  return (
<>
    <>
    <div  className='oat-addmain'>

<ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
          
    
          <div className="oat-addgrid-layout">
    <div className="oat-addmain-top">
        <div className='oat-addmain-back'>
          
        </div> 
          
           <span className='OatTitle'>
    <span>EDIT USER</span></span>
    <div className='oat-addmain-back'>
      <Link to="/Oatadduser"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     </div>
 </div>
             {/* Alert Messages */}
   {/* Generated success */}
    
    <div className='oat-toastpop-fade' id="GenerateSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Generated successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 {/* Update success */}
    
 <div className='oat-toastpop-fade' id="UpdateSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Updated successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>


       {/* EditPopup */}


<div className="modal-dialog" role="document">
      <div className="modal-content">
      
   <form  id="editoatform" onSubmit={()=>updateoat()}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
          <input type="text" id="EditName"  defaultValue={userName} />
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">

          <input type="text" defaultValue={email} readOnly/>

          </div>
        <div className="md-form mb-5">
       <input  value={passwordHash} id="Gpassword"/>
       {/* <input type="checkbox"   id="GenerateCheck" onClick={ChangePassword}/>&nbsp; */}
          <span className='col-sm-7'  id="Generateoatbox" ><span id="Gpass">Password</span></span> 
         <button id="Generateoatbtn" className='col-sm-4' type='button' onClick={GeneratePassword} >Generate</button>
    
         </div>
        
<div className="md-form mb-3">

  


{ActiveState===0 ? 
    <center>
 <input type="checkbox" id="oatactiveswitch"
              className="Activecheckbox"   onChange={()=>setActive(1)}/>
  <label for="oatactiveswitch" className="oattoggleactive">
       

<p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


  </label>

  </center>
:
<center>
<input type="checkbox" id="oatinactiveswitch"
         class="InActivecheckbox"  onChange={()=> setActive(0)} />
<label for="oatinactiveswitch" className="oattoggleinactive">
  

<p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


</label>

</center>


 


     }
{/* <button id ='oatInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button> */}


</div>


       
      </div>
      <div className="modal-footer d-flex justify-content-center" id="oateditpopfooter">
        <button type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>



      
    
    </div>
    </>
    </>
  )
}

export default EditpopMain
